import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight, Lightbulb } from 'lucide-react';
export function CadouFinalCTA() {
  return <section className="py-24 lg:py-32 bg-[#4F2E7E] relative overflow-hidden" data-id="element-267">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-268" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-gold/5 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-269" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-[2rem] p-8 md:p-12 lg:p-16 shadow-2xl text-center" data-id="element-271">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-text mb-6 text-balance" data-id="element-272">
            Nu mai amâna claritatea de care ai nevoie.
          </h2>
          <div className="h-1 w-24 bg-brand-gold rounded-full mx-auto mb-10" data-id="element-273" />

          <div className="flex items-start gap-4 bg-brand-gold/5 border border-brand-gold/30 rounded-2xl p-6 md:p-8 mb-10 text-left" data-id="element-274">
            <div className="w-12 h-12 bg-brand-gold/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-275">
              <Lightbulb className="w-6 h-6 text-brand-gold" data-id="element-276" />
            </div>
            <div data-id="element-277">
              <h4 className="font-bold text-lg text-brand-text mb-2" data-id="element-278">
                Cel mai rău lucru care se poate întâmpla
              </h4>
              <p className="text-brand-text/85 leading-relaxed" data-id="element-279">
                ...este să pleci după sesiune cu o claritate totală legat de ce
                te blochează și ce ai de făcut de azi înainte. Chiar dacă nu
                lucrezi cu mine după aceea, acei 30 de minute îți pot schimba
                perspectiva asupra vieții tale.
              </p>
            </div>
          </div>

          <a href="https://wa.me/40726042604" target="_top" className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-white font-heading font-bold text-xl md:text-2xl px-8 md:px-10 py-5 md:py-6 rounded-2xl hover:bg-brand-purple transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1 w-full sm:w-auto" data-id="element-280">
            <Calendar className="w-6 h-6" data-id="element-281" />
            Programează Sesiunea Gratuită Acum
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-282" />
          </a>

          <p className="mt-6 text-sm text-brand-textSec italic" data-id="element-283">
            Locuri limitate. Programările se fac în ordinea înscrierilor.
          </p>
        </motion.div>
      </div>
    </section>;
}